var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var SmdPadstackData = require('../../../padstack/smdPadstackData.js');
var PadData = require('../../padData.js');
var Component = require('./component.js');
var ComponentAttribute = require('./componentAttribute.js');
var RectangleData = require('../../../svg/rectangleData.js');
var AbstractIPCData = require("../../../abstract/abstractIPCData.js");
var IPCRules = require('../ipcRules.js');
var ThermalConnectionTypes = require("../../../thermalConnectionTypes.js");
var CustomSmdPadGeneratorData = require("./customSmdPadGeneratorData.js")
/**
 * @constructor
 * @param {object} root
 * @param {lib_geometry.Coord} position
 * @param {number} angle Angle in degrees
 * @param {boolean} init Initialize members
 */
var IpcSmdPadGeneratorData = function(position, angle, init) {
    AbstractIPCData.apply(this, arguments);

    /////////////////////////////
    // IPC SMD parameters list //
    /////////////////////////////
    this.addCustomFootprintMembers()
    //lead to lead span for left and right pads (horizontal span)
    this.horizontalLeadToLeadSpanMax = this.value("horizontalLeadToLeadSpanMax", true);
    this.horizontalLeadToLeadSpanMin = this.value("horizontalLeadToLeadSpanMin", true);

    //normal pad width
    this.padWidthMax = this.value("padWidthMax", true);
    this.padWidthMin = this.value("padWidthMin", true);

    //normal pad height
    this.padHeightMax = this.value("padHeightMax", true);
    this.padHeightMin = this.value("padHeightMin", true);

    //body offset from landing plane
    this.bodyOffsetMax = this.value("bodyOffsetMax", true);
    this.bodyOffsetMin = this.value("bodyOffsetMin", true);

    //tolerances
    this.fabricationTolerance = this.value("fabricationTolerance", true);
    this.placementTolerance = this.value("placementTolerance", true);

    this.update3dModelNonTriggerList.push("fabricationTolerance");
    this.update3dModelNonTriggerList.push("placementTolerance");

    this.nonTransformedSegmentedGeometry.addTrigger(this.fabricationTolerance);
    this.nonTransformedSegmentedGeometry.addTrigger(this.placementTolerance);

    if(init) {
        this.fabricationTolerance(50);
        this.placementTolerance(25);
        this.padShape(ComponentAttribute.padShapes["Rectangle"]);
    }
};

lib_core.inherit(IpcSmdPadGeneratorData, AbstractIPCData);
lib_core.JsonParser.registerClass(IpcSmdPadGeneratorData, "IpcSmdPadGeneratorData");

lib_core.mixin(IpcSmdPadGeneratorData, CustomSmdPadGeneratorData);
module.exports = IpcSmdPadGeneratorData;

IpcSmdPadGeneratorData.prototype.initialize = function() {
    AbstractIPCData.prototype.initialize.call(this);

    //non-persistent component is used to calculate actual pad geometry from IPC params
    this.component = new Component(this);
};

IpcSmdPadGeneratorData.prototype.setupMinMaxPtrMap = function() {
    AbstractIPCData.prototype.setupMinMaxPtrMap.call(this);

    this.minMaxPointerMap["horizontalLeadToLeadSpan"] = [this.horizontalLeadToLeadSpanMin, this.horizontalLeadToLeadSpanMax];
    this.minMaxPointerMap["padWidth"] = [this.padWidthMin, this.padWidthMax];
    this.minMaxPointerMap["padHeight"] = [this.padHeightMin, this.padHeightMax];
    this.minMaxPointerMap["bodyOffsetAndHeight"] = [this.bodyOffsetMin, this.bodyHeightMax];
    this.validationMap["padWidthMax"] = [this.padWidthMax];
    this.validationMap["padHeightMax"] = [this.padHeightMax];
    this.validationMap["horizontalLeadToLeadSpanMax"] = [this.horizontalLeadToLeadSpanMax];
    //custom  footprint params
    this.validationMap["customPadWidth"] = [this.customPadWidth]; 
    this.validationMap["customOddPadWidth"] = [this.customOddPadWidth];
    this.validationMap["customPadLength"] = [this.customPadLength];
    this.validationMap["customOddPadLength"] = [this.customOddPadLength];
    this.validationMap["customPadToPadGap"] = [this.customPadToPadGap]; 
    this.validationMap["customPadToPadGap1"] = [this.customPadToPadGap1]; 
    this.validationMap["customPadDiameter"] = [this.customPadDiameter];
    this.validationMap["customPadSpan1"] = [this.customPadSpan1];
    this.validationMap["customPadSpan2"] = [this.customPadSpan2];
    this.validationMap["customPadPitch"] = [this.customPadPitch];
    this.validationMap["pinPitch1"] = [this.pinPitch1];
};

/**
 * Update helper component object and recalculate the pads geometry.
 * @param  {number} leadToLeadSpanMin    Lead-lead span minimum
 * @param  {number} leadToLeadSpanMax    Lead-lead span maximum
 * @param  {boolean} enableUpdateHeelGoal Flag to enable updataion of heel goal which depends on component type.
 */
IpcSmdPadGeneratorData.prototype.updateComponentCalculator = function(leadToLeadSpanMin, leadToLeadSpanMax, enableUpdateHeelGoal) {
    var self = this;

    //update lead to lead span
    if (leadToLeadSpanMin) self.component.leadToLeadSpanMin = leadToLeadSpanMin;
    if (leadToLeadSpanMax) self.component.leadToLeadSpanMax = leadToLeadSpanMax;

    //initialize the component again to update component pad goals
    self.component.init();

    if(enableUpdateHeelGoal === undefined) enableUpdateHeelGoal = true;
    self.component.calculatePadsGeometry(enableUpdateHeelGoal);
};

/**
 * Create an instance of motif object (pad data with smd pad stack) and update pad shape by IPC calculated values
 * @return {PadData} Pad data.
 */
IpcSmdPadGeneratorData.prototype.getMotif = function() {
    var self = this;

    var shape = new RectangleData(new lib_geometry.Coord(0, 0), 0, 0, 0, true, 0);
    shape.width(self.component.X); //update shape with IPC param
    shape.height(self.component.Y);

    var padstack = new SmdPadstackData(shape, true, false, 101.6, true, false, 0, ThermalConnectionTypes.RELIEF);
    var motif = new PadData(new lib_geometry.Coord(0, 0), 0, "__smdPadReplicatorMotif__", padstack, true);

    //update pad shapes
    self.updatePadShape(motif);

    return motif;
};

/**
 * Update motif
 * @param  {object} motif The motif to be updated
 * @param  {number} width New width
 * @param  {number} motif New height
 */
IpcSmdPadGeneratorData.prototype.updateMotif = function(motif, width, height) {
    var self = this;

    motif.padstack().topCopper().width(width); //update pad shape used in pad stack
    motif.padstack().topCopper().height(height);

    //update pad shapes
    self.updatePadShape(motif);
};

IpcSmdPadGeneratorData.prototype.updatePadShape = function(motif) {
    var self = this;

    if(self.padShape() === ComponentAttribute.padShapes["Rectangle"]) {
        motif.padstack().topCopper().rx(0);
        motif.padstack().topCopper().ry(0);
    } else if(self.padShape() === ComponentAttribute.padShapes["Oblong"]) {
        var cornerRadius = Math.min(motif.padstack().topCopper().height(), motif.padstack().topCopper().width()) * IPCRules.oblongPadCornerRadiusSize;
        motif.padstack().topCopper().rx(cornerRadius);
        motif.padstack().topCopper().ry(cornerRadius);
    } else if(self.padShape() === ComponentAttribute.padShapes["RoundedRectangle"]) {
        var cornerRadius = Math.min(motif.padstack().topCopper().height(), motif.padstack().topCopper().width()) * (self.roundedPadCornerSize() / 100);

        //check radius size limit
        //TODO: use user preference settings and make limit field visible to user
        /*if(cornerRadius > IPCRules.roundedPadCornerRadiusSizeLimit) {
            cornerRadius = IPCRules.roundedPadCornerRadiusSizeLimit;
        }*/

        motif.padstack().topCopper().rx(cornerRadius);
        motif.padstack().topCopper().ry(cornerRadius);
    }
};